// extracted by mini-css-extract-plugin
export default {"wrapper":"InstallButton_wrapper__WdD9k","button":"InstallButton_button__zBNeW"};